import * as React from "react";
import { cn } from "../../lib/utils";

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, invalid, rows = 4, ...props }, ref) => (
    <textarea
      ref={ref}
      rows={rows}
      aria-invalid={invalid || undefined}
      className={cn(
        "w-full px-space-3 py-[10px]",
        // text-body (16px) below sm stops iOS Safari's focus auto-zoom;
        // ≥sm keeps the original text-small so desktop is pixel-identical.
        "font-body text-body sm:text-small text-onyx bg-white-pure leading-normal",
        "border border-border-light rounded-md",
        "placeholder:text-gray-mid",
        "transition-colors duration-fast ease-standard resize-y",
        "focus:outline-none focus:border-gold focus:shadow-goldRing",
        "disabled:bg-white-warm disabled:opacity-60 disabled:cursor-not-allowed",
        invalid && "border-status-error focus:border-status-error",
        className
      )}
      {...props}
    />
  )
);
Textarea.displayName = "Textarea";
